import { gaEvent } from 'src/utils'

/**
 * Parâmetro para {@link genericEvent}
 */
export type GenericEvent = {
  event: string
  category: string
  action: string
  label: string
  [key: string]: unknown
}

/**
 * [TARGET]: registrar evento genérico
 *
 * [CONTEXTO]: deve ser utilizada para disparo de um evento genérico
 *
 * [REGRAS]:
 * - n/a
 *
 * @param config - Objeto com dados do evento
 */
export const genericEvent = ({ event, category, action, label, ...rest }: GenericEvent) => {
  gaEvent({
    event,
    'event-category': category,
    'event-action': action,
    'event-label': label,
    ...rest,
  })
}
